import { createAction } from '@reduxjs/toolkit';
import { MANAGE_VIEW_ACTIONS } from './viewActionConstants';

export interface IUserRatingBase {
  Context: string;
  createdDate: string;
}

export interface IShowRatingInCenter {
  showInCenter: boolean;
}

export const setUserRatingData = createAction(
  MANAGE_VIEW_ACTIONS.SET_USER_RATING_DATE,
  function prepare(allRating: IUserRatingBase) {
    return {
      payload: allRating,
    };
  }
);

export const showRatingInCenter = createAction(
  MANAGE_VIEW_ACTIONS.SET_SHOW_RATING_IN_CENTER,
  function prepare(data: IShowRatingInCenter) {
    return {
      payload: data,
    };
  }
);

export const setRatingConfig = createAction(
  MANAGE_VIEW_ACTIONS.SET_RATING_CONFIG,
  function prepare(ratingFrequency: number) {
    return {
      payload: ratingFrequency,
    };
  }
);
